import { Capacitor } from "@capacitor/core";
import { Preferences } from "@capacitor/preferences";
import { InAppReview } from "@capacitor-community/in-app-review";
import { isNativeApp } from "./platform";
import logger from "./logger";

// #124: la recensione si chiede una volta, dopo che chi crea ha condiviso il
// secondo puzzle: è il momento in cui l'app ha funzionato per lui.
const CONDIVISI_KEY = "puzzly_review_shared";
const CHIESTA_KEY = "puzzly_review_asked";

export const SCHEDA_STORE = {
  android: "https://play.google.com/store/apps/details?id=com.giadalabs.puzzly",
  ios: "https://apps.apple.com/app/id6822469289?action=write-review",
};

async function giaChiesta() {
  const { value } = await Preferences.get({ key: CHIESTA_KEY });
  return value === "1";
}

// Segna che questo puzzle è stato condiviso. Torna true quando è ora di chiedere:
// almeno due puzzle diversi condivisi e la richiesta mai fatta.
export async function segnaCondivisione(puzzleId) {
  if (!isNativeApp() || !puzzleId) return false;
  try {
    if (await giaChiesta()) return false;
    const { value } = await Preferences.get({ key: CONDIVISI_KEY });
    const condivisi = value ? JSON.parse(value) : [];
    if (!condivisi.includes(puzzleId)) {
      condivisi.push(puzzleId);
      await Preferences.set({ key: CONDIVISI_KEY, value: JSON.stringify(condivisi.slice(-2)) });
    }
    return condivisi.length >= 2;
  } catch (err) {
    logger.warn("review: share count failed", { error: err.message });
    return false;
  }
}

// Il foglio nativo di Play o di Apple. Gli store decidono poi se mostrarlo
// davvero (Apple al massimo tre volte l'anno); noi lo chiediamo una volta sola.
export async function chiediRecensione() {
  if (!isNativeApp()) return false;
  try {
    if (await giaChiesta()) return false;
    await Preferences.set({ key: CHIESTA_KEY, value: "1" });
    await InAppReview.requestReview();
    logger.info("review: requested");
    return true;
  } catch (err) {
    logger.warn("review: request failed", { error: err.message });
    return false;
  }
}

// «Valuta Puzzly» nel Profilo: la scheda dell'app nello store di questo telefono.
export function apriSchedaStore() {
  const url = SCHEDA_STORE[Capacitor.getPlatform()];
  if (!url) return false;
  window.open(url, "_blank");
  return true;
}
